import en from './invoices.en';

const enConfig = { en };

export default enConfig;
